import { Button, Col, Input, Modal, QRCode, Row, Typography } from "antd";
import "./userTotpDisableModal.scss";
import React, { useEffect, useState } from "react";
import Icon from "../icon/icon";
import { HandleErrors } from "../../utils/handleErrors";
import { userDisableTotpCodeService } from "../../services/user.service";
import { toast } from "react-toastify";

interface Props {
  show: boolean;
  onClose: () => void;
}

export const UserTotpDisableModal: React.FC<Props> = (props) => {
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);

  const [code, setCode] = useState("");

  useEffect(() => {
    setShow(props.show);
    if(props.show){
      setCode("")
    }
  }, [props.show]);

  const submit = async () => {
    try {
      setLoading(true);
      const res = await userDisableTotpCodeService({
        totp: code,
      });
      setLoading(false);
      toast.success("ورود دومرحله‌ای با موفقیت غیرفعال شد");
      setShow(false);
      props.onClose();
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  return (
    <div className="UserTotpDisableModal">
      <Modal
        destroyOnClose={true}
        title={"حذف Authenticator تنظیم شده"}
        onCancel={() => {
          setShow(false);
          props.onClose();
        }}
        open={show}
        footer={null}
        width={550}
      >
        <div className="UserTotpDisableModalContent">
          <Row justify={"center"}>
            <Col>
              <Icon src="/assets/icons/err-notif.svg" />
            </Col>
          </Row>
          <Row justify={"center"}>
            <Typography.Text className="title">
              آیا از حذف OTP تنظیم شده مطمئن هستید؟
            </Typography.Text>
          </Row>
          <Row>
            <Col xs={24}>
              <Input.OTP
                value={code}
                onChange={(e) => {
                  setCode(e);
                }}
              />
            </Col>
          </Row>
          <Row
            justify={"space-between"}
            align={"middle"}
            style={{
              marginTop: 20,
            }}
          >
            <Col xs={11}>
              <Button onClick={submit} loading={loading} block className="btn">
                حذف
              </Button>
            </Col>
            <Col xs={11}>
              <Button
                onClick={() => {
                  props.onClose();
                  setShow(false);
                }}
                block
                type="primary"
                className="btn"
              >
                انصراف
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
};
